"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _core.makeStyles)(theme => ({
  root: {
    width: 50,
    height: 24,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(26px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: _constants.colours.activeState,
        opacity: 1,
        border: 'none'
      },
      '&.Mui-disabled + $track': {
        backgroundColor: _constants.colours.inactiveState
      }
    },
    '&.Mui-disabled': {
      color: '#bdbdbd'
    }
  },
  thumb: {
    width: 22,
    height: 22
  },
  track: {
    borderRadius: 24 / 2,
    backgroundColor: _constants.colours.inactiveState,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}));

const CustomSwitch = props => {
  const classes = useStyles(props);
  return /*#__PURE__*/_react.default.createElement(_core.Switch, _extends({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props));
};

var _default = CustomSwitch;
exports.default = _default;